import PropTypes from "prop-types";
import styles from "./style.module.scss";
const GenericButton = ({ title, onClick, type }) => {
  return (

    type ?

      <button className={styles.button} onClick={onClick}>
        <div className={styles.text}> {title} </div>
      </button>
      :
      <button className={styles.button2} onClick={onClick}>
        <div className={styles.text2}> {title} </div>
      </button>
  );
};

GenericButton.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
};

GenericButton.defaultProps = {
  title: "Click Me!",
  onClick: () => {
  },
};

export default GenericButton;
